import { Button, ButtonTheme } from '@apply/components';
import { useNavigate } from 'react-router';
import { IDashboardDrawBudget } from '@apply/api/src/api/DrawApi';

interface ContinueDrawButtonProps {
    dashboardDrawBudget: IDashboardDrawBudget;
}
export const ContinueDrawButton = ({ dashboardDrawBudget }: ContinueDrawButtonProps) => {
    const navigate = useNavigate();

    const handleClick = () => {
        navigate(`/draw/${dashboardDrawBudget.drawBudgetId}`);
    };

    return (
        <Button
            id='secondaryButton'
            theme={ButtonTheme.Secondary}
            width='160px'
            handleClick={handleClick}
            disabled={false}
        >
            Continue Draw
        </Button>
    );
};
